import React from 'react';
import { Badge, Box, Button, Stack, SvgIcon } from '@mui/material';
import AdjustmentsHorizontalIcon from '@heroicons/react/24/outline/AdjustmentsHorizontalIcon';
import { useIsMobile } from '../hooks/use-is-mobile';
import { MobileBottomSheet } from './mobile/mobile-bottom-sheet';

export function ResponsiveFilterBar({ children, sx, title = 'Filters', activeCount = 0, buttonSx }) {
  const isMobile = useIsMobile();
  const [open, setOpen] = React.useState(false);

  if (!isMobile) {
    return <Box sx={sx}>{children}</Box>;
  }

  return (
    <>
      <Badge color="primary" badgeContent={activeCount} invisible={!activeCount} sx={buttonSx}>
        <Button
          variant="outlined"
          onClick={() => setOpen(true)}
          startIcon={
            <SvgIcon fontSize="small">
              <AdjustmentsHorizontalIcon />
            </SvgIcon>
          }
          sx={{ height: 40, borderRadius: 999, bgcolor: 'background.paper', whiteSpace: 'nowrap' }}
        >
          {title}
        </Button>
      </Badge>
      <MobileBottomSheet
        open={open}
        onClose={() => setOpen(false)}
        title={title}
        keepMounted
        footer={
          <Button fullWidth size="large" variant="contained" onClick={() => setOpen(false)}>
            Show results
          </Button>
        }
      >
        <Stack
          spacing={2}
          sx={{
            pt: 1,
            '& > *': { width: '100% !important', maxWidth: 'none !important', ml: '0 !important' },
          }}
        >
          {children}
        </Stack>
      </MobileBottomSheet>
    </>
  );
}
